import * as React from "react";
import { Transition } from "react-transition-group";
import { getBackgroundColorClass } from "../../colors/index.mjs";
import { HashTrigger } from "../../hash-trigger/hash-trigger.mjs";
import { isOnScreen, scrollToElement } from "../../helpers/helper/index.mjs";
import { VisibilityProvider } from "../../helpers/visibility-provider/visibility-provider.mjs";
import { AccordionContext } from "../accordion/accordion.mjs";
import { AccordionItemContext } from "./accordion-item-context.mjs";
const AccordionItem = (props) => {
  var _a;
  const { openItems, setOpenItems } = React.useContext(AccordionContext);
  const isOpen = (_a = props.isOpen) != null ? _a : openItems.indexOf(props.id) > -1;
  const handleToggle = (isOpen2) => {
    if (props.onToggle) {
      props.onToggle(isOpen2);
    }
    setOpenItems(props.id, isOpen2);
  };
  return /* @__PURE__ */ React.createElement(AccordionItemInner, { ...props, isOpen: isOpen || false, onToggle: handleToggle });
};
const _AccordionItemInner = class _AccordionItemInner extends React.Component {
  constructor(props) {
    super(props);
    this.accordion = null;
    this.handleTransitionEnd = (event) => {
      const { isOpen } = this.props;
      if (event.target === this.accordion && event.propertyName === "height") {
        if (isOpen) {
          this.setExpanded();
        } else {
          this.setCollapsed();
        }
        this.scroll();
        this.setState({
          isAnimating: false
        });
      }
    };
    this.handleMatch = () => {
      if (!this.props.isOpen) {
        this.props.onToggle(true);
      }
    };
    this.handleClick = this.handleClick.bind(this);
    this.isInitial = true;
    this.state = {
      collapseStyle: {
        height: "0px",
        overflow: "hidden",
        visibility: "hidden"
      },
      isAnimating: false
    };
  }
  componentDidMount() {
    if (this.props.isOpen) {
      this.setExpanded();
    }
  }
  UNSAFE_componentWillReceiveProps() {
    this.isInitial = false;
  }
  componentDidUpdate(prevProps) {
    if (!this.accordion) {
      return;
    }
    if (this.props.isOpen !== prevProps.isOpen && !this.state.isAnimating) {
      this.setState({
        isAnimating: true
      });
    }
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setContentStyleProperty("height", "".concat(this.accordion.scrollHeight, "px"));
      this.setContentStyleProperty("visibility", "visible");
    } else if (!this.props.isOpen && prevProps.isOpen) {
      this.setContentStyleProperty("height", "".concat(this.accordion.scrollHeight, "px"));
      requestAnimationFrame(() => {
        setTimeout(() => {
          this.setContentStyleProperty("height", "0px");
          this.setContentStyleProperty("overflow", "hidden");
        }, 0);
      });
    }
  }
  backgroundColorClass() {
    const { background } = this.props;
    if (background) {
      if (background === "transparent") {
        return "accordion__item--transparent";
      } else {
        return getBackgroundColorClass(background);
      }
    }
  }
  BEM() {
    const classArray = ["accordion__item"];
    const backgroundColorClass = this.backgroundColorClass();
    if (this.props.isOpen) {
      classArray.push("is-open");
    }
    if (this.props.isInactive) {
      classArray.push("is-inactive");
    }
    if (this.props.type) {
      classArray.push("accordion__item--" + this.props.type);
    }
    if (backgroundColorClass) {
      classArray.push(backgroundColorClass);
    }
    if (this.props.icon) {
      classArray.push("accordion__item--icon");
    }
    if (this.props.noContent) {
      classArray.push("accordion__item--no-content");
    }
    if (this.state.isAnimating) {
      classArray.push("is-animating");
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  handleClick(event) {
    event.preventDefault();
    this.props.onToggle(!this.props.isOpen);
  }
  scroll() {
    if (!this.isInitial && this.context.openItems.indexOf(this.props.id) > -1 && !isOnScreen(this.props.id)) {
      scrollToElement("".concat(this.props.id, "-header"));
    }
  }
  setContentStyleProperty(property, value) {
    this.setState((prevState) => {
      const newStyle = {
        [property]: value
      };
      return {
        collapseStyle: { ...prevState.collapseStyle, ...newStyle }
      };
    });
  }
  setCollapsed() {
    this.setContentStyleProperty("visibility", "hidden");
  }
  setExpanded() {
    this.setContentStyleProperty("height", "auto");
    this.setContentStyleProperty("overflow", "visible");
    this.setContentStyleProperty("visibility", "visible");
  }
  get contextValue() {
    return {
      accordionRef: (el) => this.accordion = el,
      collapseStyle: this.state.collapseStyle,
      icon: this.props.icon,
      id: this.props.id,
      isOpen: this.props.isOpen,
      noContent: this.props.noContent,
      onClick: this.handleClick
    };
  }
  render() {
    return /* @__PURE__ */ React.createElement(AccordionItemContext.Provider, { value: this.contextValue }, /* @__PURE__ */ React.createElement(VisibilityProvider, { isVisible: this.props.isOpen && !this.state.isAnimating }, /* @__PURE__ */ React.createElement(Transition, { in: this.props.isOpen, timeout: { enter: 0, exit: 0 } }, /* @__PURE__ */ React.createElement(HashTrigger, { id: this.props.id, onMatch: this.handleMatch, renderWrapper: false }, /* @__PURE__ */ React.createElement("div", { className: this.BEM(), onTransitionEnd: this.handleTransitionEnd }, this.props.children)))));
  }
};
_AccordionItemInner.contextType = AccordionContext;
let AccordionItemInner = _AccordionItemInner;
export {
  AccordionItem
};
